import { render } from "./ReceiptUpdate.vue?vue&type=template&id=42f7d047&scoped=true"
import script from "./ReceiptUpdate.vue?vue&type=script&lang=js"
export * from "./ReceiptUpdate.vue?vue&type=script&lang=js"

import "./ReceiptUpdate.vue?vue&type=style&index=0&id=42f7d047&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42f7d047"]])

export default __exports__